import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box, Button, Fade, Typography } from '@mui/material';
import React from 'react';

interface IProps {
  title: string;
  message: string;
  isOpen: boolean;
  isClosing: boolean;
  onClose: () => void;
}

const slideStyles = {
  '@keyframes slideIn': {
    from: { opacity: 0, transform: 'translateX(-16px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
  '@keyframes slideOut': {
    from: { opacity: 1, transform: 'translateX(0)' },
    to: { opacity: 0, transform: 'translateX(-16px)' },
  },
};

const arrowStyles = {
  position: 'absolute',
  top: 16,
  left: -5,
  width: 10,
  height: 10,
  backgroundColor: 'common.white',
  borderLeft: '1px solid',
  borderBottom: '1px solid',
  borderColor: 'divider',
  transform: 'rotate(45deg)',
  zIndex: 1,
};

const alertStyles = {
  paddingX: 2,
  paddingTop: 2,
  paddingBottom: 1,
  backgroundColor: 'common.white',
  width: 420,
  height: 190,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  boxShadow: 2,
  '& .MuiAlert-message': { width: '100%', p: 0, display: 'flex', flexDirection: 'column', flex: 1 },
};

export const ClaimLinkTypeInfoAlert: React.FC<IProps> = ({ title, message, isOpen, isClosing, onClose }) => {
  return (
    <Fade in={isOpen && !isClosing} timeout={{ enter: 300, exit: 200 }} unmountOnExit>
      <Box sx={{ position: 'relative' }}>
        {/* Tooltip arrow pointing left */}
        <Box sx={arrowStyles} />
        <Alert severity="info" icon={false} sx={alertStyles}>
          <Box
            sx={{
              ...slideStyles,
              animation: isClosing ? 'slideOut 250ms ease-in forwards' : 'slideIn 300ms ease-out forwards',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              height: '100%',
            }}
          >
            <Box sx={{ display: 'flex', gap: 1.5, mb: 0.75 }}>
              <InfoOutlinedIcon sx={{ width: 20, height: 20, flexShrink: 0 }} color="action" />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Typography fontWeight="medium" color="text.primary" sx={{ fontSize: 18, lineHeight: 1.3 }}>
                  {title}
                </Typography>
                <Typography sx={{ fontSize: 14 }} color={'text.secondary'}>
                  {message}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={onClose}
                data-action="template_info_got_it_btn"
              >
                Got it
              </Button>
            </Box>
          </Box>
        </Alert>
      </Box>
    </Fade>
  );
};
